import React from 'react'
import update from 'immutability-helper';
import DropzoneComponent from 'react-dropzone-component';
import { browserHistory } from 'react-router';
import Modal from 'react-modal';
import moment from 'moment'

import NavLink from '../Routes/NavLink'
import TenantPaymentHistory from '../Billing/TenantPaymentHistory'

import { phoneNumberFormatter } from '../../helpers/General/PhoneNunberFormatter'
import { tenant } from '../../core/controllers/Tenant';
import { documents } from '../../core/controllers/Documents';
import { dropZone } from '../../core/utilities/DropZoneHandler';
import { modal } from '../../core/utilities/modal';
import { lease } from '../../core/controllers/Lease';
import { modalStyles } from '../../core/controllers/ModalStyles';
import { user } from '../../core/controllers/user';

import ActionCenterCard from '../../helpers/Cards/ActionCenter';
import { ActionCenterEntry } from '../../helpers/Cards/ActionCenter';
import { financial } from '../../core/controllers/Financial';
import PropertiesSelect from '../Properties/PropertiesSelect';
import LeaseSelect from '../Leases/LeaseSelect';
import OwnersSelect from '../../helpers/Owner/OwnersSelect';
import WorkOrdersSelect from '../../helpers/WorkOrders/WorkOrdersSelect';
import InvoicesSelect from '../../helpers/Invoices/InvoicesSelect';
import FeesSelect from '../../helpers/Fees/FeesSelect';
import BankAccountSelect from '../../helpers/BankAccounts/BankAccountSelect';

// #  TODO move this to seperate component
const Attachment = ({attachment, deleteFunc}) => {
    return (
        <attachment key={attachment.id}>
            <div class={attachment.content_type == 'pdf' ? "col-lg-12 col-md-12 col-sm-12 col-xs-12 col-xs-12" : "col-lg-3 col-md-3 col-sm-4 col-xs-6 col-xs-6"}>
                <span class="deleteDocument" onClick={deleteFunc.bind(this, attachment)}><i class="pe-7s-close"></i></span>
                <a href={attachment.url} target="_blank">
                    { attachment.content_type == 'pdf' ? (
                        <object width="100%" height="500" data={attachment.url} type="application/pdf"></object>
                    ) : (
                        <img src={attachment.url} width="100px" height="100px" />
                    )}
                </a>
            </div>
        </attachment>
    );
};

export default class TenantEdit extends React.Component {
    constructor(props) {
        super(props);
        var self = this;

        this.state = {
            userLoaded: false,
            tenantID : props.tenantID,
            contract_data_id: 0,
            space_id: 0,
            attachments: null,
            can_make_manual_payment: 0,
            tenantData: {
                tenant_phone: null
            },
            emailTenant: true,
            propertyName: "",
            propertyUnit: "",
            leaseStatus: "N/A",
            leaseName: "",
            leaseID: 0,
            lateRent: false,
            prePaid: false,
            showPaymentPlanModal: false,
            showTenantPayoutModal: false,
            hasPaymentPlan: false,
            rentChanged: false,
            paymentPlanData: {
                tenant_id: props.tenantID,
                rentAmount: 0,
                termLength: 0,
                effectiveDate: '',
            },
            showTagMenu: false,
            transactionData: {
                name: '',
                description: '',
                payout: 0,
                fee_charge: 0,
                tenant_id: props.tenantID,
                fee_id: 0,
                bank_identifier: 0
            },
        };
    }

    componentDidMount() {
        var self = this;
        if(!this.props.newTenant){
            tenant.setTenantID(this.state.tenantID);
            tenant.getTenant(this, function(responses){
                if (responses.data[0] != null) {
                    self.setState({
                        can_make_manual_payment: (responses.data[0][0].can_make_manual_payment == "0") ? false : true
                    });

                    if (responses.data[0].data.tenant_late_rent == 1) {
                        self.setState({
                            lateRent: true
                        });
                    }
                    if (responses.data[0].payment_plan != null) {
                        self.setState({
                            paymentPlanData: responses.data[0].payment_plan,
                            paymentPlanData: update(self.state.paymentPlanData, {
                                rentAmount: {$set: responses.data[0].payment_plan.total_amount},
                                termLength: {$set: responses.data[0].payment_plan.total_term_months},
                                effectiveDate: {$set: responses.data[0].payment_plan.created_at},
                                payment_plan_id: {$set: responses.data[0].payment_plan.payment_plan_id},
                            }),
                            hasPaymentPlan: true,
                        })
                    }
                    if (responses.data[0].contract_data != null) {
                        lease.setLeaseID(responses.data[0].contract_data.contract_id);
                        lease.getLease(function(response){
                            if (response.data[0] != null) {
                                if (response.data[0].data.prepaid_end_date != null) {
                                    self.setState({
                                        prePaid: true,
                                    })
                                }
                                if (response.data[0].property != null) {
                                    self.setState({
                                        propertyName: response.data[0].property.property_name,
                                    })
                                }
                                if (response.data[0].belongTo != null) {
                                    self.setState({
                                        leaseID: response.data[0].belongTo.contract_id,
                                    })
                                }
                                if (response.data[0].assigned_property_unit != null) {
                                    self.setState({
                                        propertyUnit: response.data[0].assigned_property_unit.unit_name,
                                    })
                                }
                                if (response.data[0].data.contract_expiration_date != null) {
                                    self.setState({
                                        leaseStatus: self.checkLeaseStatus(moment(response.data[0].data.contract_expiration_date)),
                                        leaseName: response.data[0].data.title,
                                    })
                                }
                                if (response.data[0].tenants != null) {
                                    response.data[0].tenants.map(function(tenant){
                                        if (tenant.tenant.tenant_id == self.state.tenantID) {
                                            if (tenant.tenant_data.tenant_late_rent == 1) {
                                                self.setState({
                                                    lateRent: true,
                                                });
                                            }
                                        }
                                    })
                                }
                            }
                        })
                    }
                }
            });
        } else {
            tenant.setTenantID(0);
            tenant.setDefaultState(this);
        }

        dropZone.setup(this);

        user.getUserDataWithCallback(function(response) {
            self.setState({
                userLoaded: true
            });
        });

        jQuery(".email-checkbox").change(function(e){
            const value = jQuery(e.target).prop('checked');
            self.setState({ emailTenant: value })
        });
    }


    componentWillUpdate(nextProps, nextState) {
        if(nextState.contract_data_id === undefined) {
            nextState.contract_data_id = 0;
        }
        if(nextState.space_id === undefined) {
            nextState.space_id = 0;
        }
    }

    // #  When uploading a new tenant, the tenant_id will be passed
    triggerUpload(tenant_id, type) {
        var self = this;
        if(tenant_id != 0) {
            dropZone.setup(this, 'tenant', tenant_id, true);
        }

        dropZone.upload(type, function() {
            tenant.getTenant(self);
        });

        const isFilesAdded = dropZone.isFilesAdded();
        if (isFilesAdded == false) {
            if (type == "new_tenant") {
                modal.showSuccess("Tenant Added!","This tenant has been successfully created.");
                jQuery(".move-on").on('click',function() {
                    browserHistory.goBack();
                });
            } else {
                modal.showInfo("There is no pending file to upload!", "warning", "top", "center");
            }
        }
    }

    sortSpaceSelect(e) {
        this.setState({
            space_id: e.target.value
        });
    }

    handleFirstnameChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_firstname: {$set: e.target.value
                }}
            )
        });
    }

    handleLastnameChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_lastname: {$set: e.target.value
                }}
            )
        });
    }

    handleEmailChange(e){
        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_email: {$set: e.target.value
                }}
            )
        });
    }

    handlePhoneChange(e){
        var phoneNumber = phoneNumberFormatter.format(e.target.value);

        this.setState({
            tenantData: update(this.state.tenantData, {
                tenant_phone: {$set: phoneNumber
                }}
            )
        });
    }

    handleCompanyChange(e) {
        this.setState({
            tenantData: update(this.state.tenantData, {
                company: {$set: e.target.value
                }}
            )
        });
    }

    validate() {
        const enteredData = this.state.tenantData;
        const email = enteredData.tenant_email;
        const firstname = enteredData.tenant_firstname;
        const lastname = enteredData.tenant_lastname;
        const emailTenant = this.state.emailTenant;
        const newTenant = this.props.newTenant;
        const filesAdded = dropZone.isFilesAdded();
        const uploadSuccess = dropZone.isUploadSuccess();

        if (!this.props.newTenant) {
            if(filesAdded == true && uploadSuccess == false) {
                modal.showInfo("You have pending files that need to be uploaded!", "warning", "top", "center");
                return false;
            }
        }

        if(firstname === undefined || firstname.length == 0) {
            modal.showInfo("You need to enter the tenant's firstname.", "warning", "top", "center");
            return false;
        }

        if(lastname === undefined || lastname.length == 0) {
            modal.showInfo("You need to enter the tenant's lastname.", "warning", "top", "center");
            return false;
        }

        if(emailTenant) {
            if(newTenant) {
                if(email === undefined || email.length == 0) {
                    modal.showInfo("You need to enter the tenant's email.", "warning", "top", "center");
                    return false;
                }
            }

            if(email && email.length > 0) {
                const lastAtPos = email.lastIndexOf('@');
                const lastDotPos = email.lastIndexOf('.');
                if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
                    modal.showInfo("Email is invalid.", "warning", "top", "center");
                    return false;
                }
            }
        } else {
            if(email && email.length > 0) {
                const lastAtPos = email.lastIndexOf('@');
                const lastDotPos = email.lastIndexOf('.');
                if (!(lastAtPos < lastDotPos && lastAtPos > 0 && email.indexOf('@@') == -1 && lastDotPos > 2 && (email.length - lastDotPos) > 2)) {
                    modal.showInfo("Email is invalid.", "warning", "top", "center");
                    return false;
                }
            }
        }

        return true;
    }

    handleSaveTenantData(e){
        if(!this.validate()) {
            return;
        }
        tenant.saveTenant(this);
    }

    handleDeleteTenant(e){
        tenant.deleteTenant(this);
    }

    handleDeleteDocument(attachment) {
        var self = this;
        documents.deleteDocument(attachment.id, function() {
            tenant.getTenant(self);
        });
    }

    renderAttachments(attachments) {
        var self = this;
        if (attachments !== null) {
            if(attachments.length > 0) {
                var attachmentsLength = attachments.length
                for (var i = 0; i < attachmentsLength; i++) {
                    if (attachments[i].content_type == "pdf") {
                        var temp = attachments[i]
                        attachments.splice(i, 1);
                        attachments.push(temp)
                    }
                }
                return attachments.map((attachment, index) => (
                    <Attachment key={index} attachment={attachment} deleteFunc={self.handleDeleteDocument.bind(self)}/>
                ));
            }
        }
    }

    activationEmail() {
        tenant.sendActivation(this.state.tenantID, function(response) {
            modal.showInfo("Tenant has been invited to join Leasey.", "success", "top", "center");
        });
    }

    checkLeaseStatus(leaseExpirationDate) {
        var monthDiff = leaseExpirationDate.diff(moment(), "months")
        var dayDiff = leaseExpirationDate.diff(moment(), "days") + 1

        if (monthDiff > 1) {
            return "Expiring in " + monthDiff + " months!"
        } else if (monthDiff == 1) {
            return "Expiring in 1 month!"
        } else {
            if(dayDiff > 1) {
                return "Expiring in " + dayDiff + " days!"
            } else if (dayDiff == 1) {
                return "Expiring in 1 day!"
            } else {
                return "Expired!"
            }
        }
    }

    onMoveOutTenant() {
        var self = this;
        modal.showSuccessModalWithOK("Redirecting...","Click Continue to see the lease that is associated with this tenant!", "Continue");
        jQuery(".move-on").on('click',function() {
            browserHistory.push('/lease/' + self.state.leaseID);
        });
    }

    onRequestRenewal() {
        const leaseID = this.state.leaseID;
        modal.showDangerModalWithOK("Warning!","You are about to renew this lease for the same amount of terms. Do you want to continue?","Yes");
        jQuery(".move-on").on('click',function() {
            lease.requestLeaseRenewal(leaseID);
        });
    }

    onToggleManualPayment() {
        const self = this;
        const tenantID = this.state.tenantID;
        const isEnabled = this.state.can_make_manual_payment;
        var text = "You are about to enable manual payments for this tenant.  Continue?"
        if (isEnabled) {
            text = "You are about to disable manual payments for this tenant.  Continue?"
        }
        modal.showDangerModalWithOK("Warning!", text,"Yes");
        jQuery(".move-on").on('click',function() {
            tenant.toggleManualPayment(tenantID, function() {
                modal.showInfo("Tenant manual payment status updated.", "success", "top", "center");
                self.setState({
                    can_make_manual_payment: !self.state.can_make_manual_payment
                });
            });
        });
    }

    handleOpenPaymentPlanModal() {
        if (this.state.userLoaded && !user.userInfo.billing_setup) {
            modal.showDangerModalWithOK("No Billing Account Found", "You need to set up a billing account first!", "Set Up Now");
            jQuery(".move-on").on('click',function() {
                browserHistory.replace('/account/billling');
            });
        } else {
            this.setState({
                showPaymentPlanModal: true,
            });
        }
    }

    handleClosePaymentPlanModal(hasChanged) {
        this.setState({
            showPaymentPlanModal: false,
        });

        if (hasChanged == true) {
            browserHistory.goBack()
        }
    }

    handleOpenTenantPayoutModal() {
        if (this.state.userLoaded && !user.userInfo.billing_setup) {
            modal.showDangerModalWithOK("No Billing Account Found", "You need to set up a billing account first!", "Set Up Now");
            jQuery(".move-on").on('click',function() {
                browserHistory.replace('/account/billling');
            });
        } else {
            this.setState({
                showTenantPayoutModal: true,
            });
        }
    }

    handleCloseTenantPayoutModal(hasChanged) {
        this.setState({
            showTenantPayoutModal: false,
        });

        // let's not go back for now
        // if (hasChanged == true) {
        //     browserHistory.goBack()
        // }
    }

    handleTitleChange(e){
        this.setState({
            transactionData: update(this.state.transactionData, {
                name: {$set: e.target.value}
            }),
        });
    }

    handleDescriptionChange(e){
        this.setState({
            transactionData: update(this.state.transactionData, {
                description: {$set: e.target.value}
            }),
        });
    }

    handleAmountChange(e){
        this.setState({
            transactionData: update(this.state.transactionData, {
                payout: {$set: e.target.value}
            }),
        });
    }

    handleBankChange(e) {
        this.setState({
            transactionData: update(this.state.transactionData, {
                bank_identifier: {$set: e.target.value
            }}
            )
        });
    }

    addTransaction(e){
        var self = this;
        var transactionAmount = this.state.transactionData.payout.toString().replace(',', '').replace('.', '');
        var bankId = this.state.transactionData.bank_identifier;
        if (transactionAmount === undefined || transactionAmount <= 0) {
            modal.showInfo("Please enter an amount for this transaction.", "danger", "top", "center");
            return false;
        } else if (isNaN(transactionAmount)) {
            modal.showInfo("Please enter a valid transaction amount.", "warning", "top", "center");
            return false;
        } else if(bankId == null || bankId == 0) {
            modal.showInfo("You need to select a bank account that you'd like funds to be sent from.", "warning", "top", "center");
            return false;
        }

        tenant.sendPayout(this.state.transactionData, function(response) {
            modal.showInfo("Payment sent to tenant!", "success", "top", "center");
            self.handleCloseTenantPayoutModal(true);
        });
    }


    buildTermsSelect() {
        var terms = [];
        for(var i = 1; i <= 36; i++) {
            terms.push(i);
        }

        return terms.map((term) => (
            <option key={'term-' + term} value={term}>{term}</option>
        ));
    }

    formatAmount(value) {
        value = value.replace(',', '');
        if(isNaN(value) || value === 0) {
            value = 0;
        } else {
            value = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(value)
        }

        return value;
    }

    onRentChange(e) {
        this.setState({
            paymentPlanData: update(this.state.paymentPlanData, {
                rentAmount: {$set: e.target.value}
            }),
            rentChanged: true
        });
    }

    onTermLengthChange(e) {
        var expirationDate = this.state.paymentPlanData.effectiveDate;
        const termLength = e.target.value;
        if(expirationDate != '') {
            expirationDate = moment(expirationDate).add(termLength, 'month').format("Y-MM-DD");
        }

        this.setState({
            paymentPlanData: update(this.state.paymentPlanData, {
                termLength: {$set: termLength},
                expirationDate: {$set: expirationDate}
            })
        });
    }

    validatePaymentPlan() {
        const rentAmount = this.state.paymentPlanData.rentAmount.toString().replace(',', '').replace('.', '');
        const termLength = this.state.paymentPlanData.termLength;

        if (rentAmount === undefined || rentAmount <= 0) {
            modal.showInfo("Enter the total payment plan amount.", "danger", "top", "center");
            return false;
        } else if (isNaN(rentAmount)) {
            modal.showInfo("Please enter a valid payment plan amount.", "warning", "top", "center");
            return false;
        }
        if (termLength == 0) {
            modal.showInfo("How long should this payment plan last?", "danger", "top", "center");
            return false;
        }

        return true;
    }

    handleCreatePaymentPlan(e){
        var self = this;
        if(!this.validatePaymentPlan()) {
            return;
        }

        tenant.createPaymentPlan(this.state.paymentPlanData, function(response) {
            modal.showInfo("Payment plan has been setup! The tenant has also been notified!", "success", "top", "center");
            self.handleClosePaymentPlanModal(true);
        });
    }

    handleUpdatePaymentPlan() {
        var self = this;
        if(!this.validatePaymentPlan()) {
            return;
        }

        tenant.updatePaymentPlan(this.state.paymentPlanData, this.state.tenantID, function(response) {
            modal.showInfo("Payment plan has been updated! The tenant has also been notified!", "success", "top", "center");
            self.handleClosePaymentPlanModal(true);
        });
    }

    handleDeletePaymentPlan() {
        var self = this;

        tenant.deletePaymentPlan(this.state.paymentPlanData, this.state.tenantID, function(response) {
            modal.showInfo("Payment plan has been deleted! The tenant has also been notified!", "success", "top", "center");
            self.handleClosePaymentPlanModal(true);
        });
    }

    openTagMenu() {
        this.setState({
            showTagMenu: !this.state.showTagMenu
        })
    }

    switchRentStatus() {
        var self = this;

        tenant.switchRentStatus(this.state.tenantID, function(response) {
            modal.showInfo("Tenant status has now been updated!", "success", "top", "center");
            self.setState({
                lateRent: !self.state.lateRent,
                showTagMenu: !self.state.showTagMenu
            })
        })
    }

    render(){
        const attachments = this.renderAttachments(this.state.attachments);
        const emailTenant = this.state.emailTenant;
        const newTenant = this.props.newTenant;
        const tenantData = this.state.tenantData;
        const active = this.state.active;
        const showTagMenu = this.state.showTagMenu;
        const bankIdentifier= this.state.transactionData.bank_identifier;
        const lateRent = this.state.lateRent;
        const prePaid = this.state.prePaid;
        const propertyName = this.state.propertyName;
        const propertyUnit = this.state.propertyUnit;
        const leaseName = this.state.leaseName;
        const makeManualPayment = this.state.can_make_manual_payment;
        var leaseDisplayName = "";
        var onLease = false;
        if (propertyName != "" && propertyUnit != "") {
            leaseDisplayName = <NavLink to={"/lease/" + this.state.leaseID}>{propertyName + ", Unit " + propertyUnit}</NavLink>;
            onLease = true;
        } else if (leaseName != "") {
            leaseDisplayName = <NavLink to={"/lease/" + this.state.leaseID}>{leaseName}</NavLink>;
            onLease = true;
        } else {
            leaseDisplayName = "N/A"
        }

        const leaseStatus = this.state.leaseStatus;
        var alertLeaseStatus = false;
        if (leaseStatus.includes("months") == true) {
            alertLeaseStatus = false
        } else {
            alertLeaseStatus = true
        }

        const paymentPlanData = this.state.paymentPlanData;
        const hasPaymentPlan = this.state.hasPaymentPlan;
        var paymentPlanText = "";
        var paymentPlanButtonText = "";
        if (hasPaymentPlan == true) {
            paymentPlanText = "Active",
            paymentPlanButtonText = "Edit Plan"
        } else {
            paymentPlanText = "Not Active",
            paymentPlanButtonText = "Set Up Plan"
        }
        var allowManualPayment = false;
        if (makeManualPayment) {
            allowManualPayment = true
        }

        const termOptions = this.buildTermsSelect();
        var rentAmount = paymentPlanData.rentAmount;
        const termLength = paymentPlanData.termLength;
        const rentChanged = this.state.rentChanged;
        var totalMonth = 0;
        if (rentAmount != null && termLength != null) {
            if ((rentAmount > 0 || rentAmount != "0") && (termLength > 0 || termLength != "0")) {
                totalMonth = rentAmount.replace(',', '');
                if (rentChanged == false) {
                    totalMonth = parseFloat(totalMonth) / parseInt(termLength) / 100;
                } else {
                    totalMonth = parseFloat(totalMonth) / parseInt(termLength);
                }

                totalMonth = totalMonth.toFixed(2);

                totalMonth = new Intl.NumberFormat('en', { maximumSignificantDigits: 10 }).format(totalMonth)
                if (isNaN(totalMonth.replace(',', ''))) {
                    totalMonth = 0;
                }
            }
        }

        if (rentChanged == false) {
            rentAmount = parseFloat(rentAmount) / 100
        }

        const screening = this.state.screening;
        var backgroundScreenText = "Not Checked";
        if (screening != null) {
            backgroundScreenText = screening.order_status
        }

        var disableRequestRenewal = true;
        if (onLease == true) {
            disableRequestRenewal = false
        }

        if(newTenant || tenantData == null) {
            return (
                <div>
                <div class="row blue-bottom-margin">
                    <div class="row">
                        <div class="sub-page-header-row col-md-11">
                            <div class="row">
                                <span class="sub-page-header-title">Add a Tenant</span>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-8">
                        <div class="card">
                            <div class="header">
                                <h4 class="title">Tenant Information</h4>
                                <p class="category"></p>
                            </div>
                            <div class="content">
                                <form>
                                    <input type="hidden" class="tenant_id" name="tenant_id" value="" />
                                    <div class="row">
                                        <div class="col-md-5 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label>First Name*</label>
                                                <input type="text" class="form-control tenant-info" name="firstname" placeholder="Firstname" id="firstname" onChange={this.handleFirstnameChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                            <div class="form-group">
                                                <label for="lastname">Last Name*</label>
                                                <input type="text" class="form-control tenant-info" name="lastname" placeholder="Lastname" id="lastname" onChange={this.handleLastnameChange.bind(this)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label for="email">Email</label>
                                                <input type="text" class="form-control tenant-info" name="email" placeholder="Email" id="email" onChange={this.handleEmailChange.bind(this)}/>
                                            </div>
                                        </div>
                                        <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                            <div class="form-group">
                                                <label for="phone">Primary Phone</label>
                                                <input type="text" class="form-control tenant-info" value={tenantData.tenant_phone} name="primaryphone" placeholder="Phone" id="phone" onChange={this.handlePhoneChange.bind(this)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-5 col-sm-6 col-xs-12">
                                            <div class="form-group">
                                                <label for="email">Company Name</label>
                                                <input type="text" class="form-control" name="companyName" placeholder="Company Name" id="company_name" onChange={this.handleCompanyChange.bind(this)}/>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12" >
                                            <div class="form-group">
                                                <p class="email-checkbox-text"><input type="checkbox" class="email-checkbox" id="email_tenant" defaultChecked={emailTenant} data-toggle="toggle"/> <b>Send tenant email invitation to portal</b></p>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="card">
                            <div class="header">
                                <h4 class="card-icon-title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-document-plus"></i></span> Documents</h4>
                                <p class="dropzone-subtitle">Upload relavant tenant documents</p>
                            </div>
                            <div class="content">
                                { this.state.dropZoneSetup !== undefined && (
                                    <DropzoneComponent config={this.state.dropZoneConfig}
                                        eventHandlers={this.state.dropZoneEventHandlers}
                                        djsConfig={this.state.dropZoneJSConfig} />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row blue-bottom">
                    <div class="blue-bottom-center-align">
                        <div class="col-md-12">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-info btn-fill" autoComplete="off" onClick={this.handleSaveTenantData.bind(this)}>
                            Create Tenant
                            </button>
                            <div class="clearfix"></div>
                        </div>
                    </div>
                </div>
                </div>
            )
        } else {
            return (
                <div>
                <div class="row blue-bottom-margin">
                    <div class="row">
                        <div class="sub-page-header-row col-md-11">
                            <div class="row">
                                <span class="sub-page-header-title">{tenantData.tenant_firstname} {tenantData.tenant_lastname}</span>
                                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", float: "right"}}>
                                    {prePaid === true && (
                                        <span class="green-sub-page-header-banner" style={{marginTop: "-80px", height: "30px"}} >
                                            PRE-PAID
                                        </span>
                                    )}
                                    <div style={{paddingLeft: "15px"}}>
                                        {lateRent == true ? (
                                            <span class="red-sub-page-header-banner hover" style={{marginTop: "-80px", height: "30px", cursor: "pointer"}} onClick={this.openTagMenu.bind(this)}>
                                                LATE RENT
                                            </span>
                                        ) : (
                                            <span class="green-sub-page-header-banner hover" style={{marginTop: "-80px", height: "30px", cursor: "pointer"}} onClick={this.openTagMenu.bind(this)}>
                                                IN GOOD STANDING
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            {showTagMenu == true && (
                            <div class="tag-menu">
                                {lateRent == true ? (
                                <span class="green-sub-page-header-banner hover" style={{marginTop: "0px", cursor: "pointer"}} onClick={this.switchRentStatus.bind(this)}>
                                    IN GOOD STANDING
                                </span>
                                ) : (
                                <span class="red-sub-page-header-banner hover" style={{marginTop: "0px", cursor: "pointer"}} onClick={this.switchRentStatus.bind(this)}>
                                    LATE RENT
                                </span>
                                )}
                            </div>
                            )}
                            {(propertyName != "" && propertyUnit != "") ? (
                            <div>
                                <div class="row">
                                    <span class="sub-page-header-submit-title" style={{fontSize: "20px"}}>
                                        {propertyName}
                                    </span>
                                </div>
                                <div class="row">
                                    <span class="sub-page-header-submit-date" style={{fontSize: "20px"}}>
                                        Unit {propertyUnit}
                                    </span>
                                </div>
                            </div>
                            ) : (
                                leaseName != "" && (
                                <div class="row">
                                    <span class="sub-page-header-submit-title" style={{fontSize: "20px"}}>
                                        {leaseName}
                                    </span>
                                </div>
                                )
                            )}
                        </div>
                    </div>
                    <div class="col-md-8 col-sm-12 col-xs-12">
                        <div class="col-md-12 card">
                            <div>
                                <div class="header">
                                    <h4 class="title">Tenant Information</h4>
                                    <p class="category"></p>
                                </div>
                                <div class="content">
                                    <form>
                                        <input type="hidden" class="tenant_id" name="tenant_id" value="" />
                                        <div class="row">
                                            <div class="col-md-5 col-sm-6 col-xs-12">
                                                <div class="form-group">
                                                    <label>First Name*</label>
                                                    <input type="text" value={tenantData.tenant_firstname} class="form-control tenant-info" name="firstname" placeholder="Firstname" id="firstname" onChange={this.handleFirstnameChange.bind(this)}/>
                                                </div>
                                            </div>
                                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                                <div class="form-group">
                                                    <label for="lastname">Last Name*</label>
                                                    <input type="text" value={tenantData.tenant_lastname} class="form-control tenant-info" name="lastname" placeholder="Lastname" id="lastname" onChange={this.handleLastnameChange.bind(this)}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5 col-sm-6 col-xs-12">
                                                <div class="form-group">
                                                    <label for="email">Email</label>
                                                    <input type="text" value={tenantData.tenant_email} class="form-control tenant-info" name="email" placeholder="Email" id="email" onChange={this.handleEmailChange.bind(this)} disabled={true}/>
                                                </div>
                                            </div>
                                            <div class="col-md-5 col-sm-6 col-xs-12 col-md-offset-1">
                                                <div class="form-group">
                                                    <label for="phone">Primary Phone</label>
                                                    <input type="text" value={tenantData.tenant_phone} class="form-control tenant-info" name="primaryphone" placeholder="Phone" id="phone" onChange={this.handlePhoneChange.bind(this)}/>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-5 col-sm-6 col-xs-12">
                                                <div class="form-group">
                                                    <label for="email">Company Name</label>
                                                    <input type="text" value={tenantData.company} class="form-control" name="companyName" placeholder="Company Name" id="company_name" onChange={this.handleCompanyChange.bind(this)}/>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 card">
                            <div class="">
                                <div class="header">
                                    <h4 class="title">Payment History</h4>
                                    <p class="category">History of all tenant transactions.  <small>Payments take 3 - 4 business days.</small></p>
                                </div>
                                <div class="content">
                                    <TenantPaymentHistory hideLinkAccount={true} tenantId={this.state.tenantID} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-12 col-xs-12">
                        <ActionCenterCard>
                            <ActionCenterEntry
                                title="Lease"
                                description={leaseDisplayName}
                                buttonText="Move Out"
                                buttonCallback={this.onMoveOutTenant.bind(this)}
                                hideButton={onLease != true}
                            />
                            <ActionCenterEntry
                                title="Lease Status"
                                description={leaseStatus}
                                buttonText="Request Renewal"
                                buttonCallback={this.onRequestRenewal.bind(this)}
                                danger={alertLeaseStatus}
                            />
                            <ActionCenterEntry
                                title="Portal"
                                description= {active == true ? (
                                    "Activated"
                                ) : (
                                    "Not Activated"
                                )}
                                disabled={active}
                                buttonText="Invite Tenant"
                                buttonCallback={this.activationEmail.bind(this)}
                            />
                            <ActionCenterEntry
                                title="Manual Payments"
                                description={this.state.can_make_manual_payment ? "Currently Enabled" : "Currently Disabled"}
                                buttonText={this.state.can_make_manual_payment ? "Disable" : "Enable"}
                                buttonCallback={this.onToggleManualPayment.bind(this)}
                                danger={this.state.can_make_manual_payment}
                            />
                            <ActionCenterEntry
                                title="Payment Plan"
                                description={paymentPlanText}
                                buttonText={paymentPlanButtonText}
                                buttonCallback={this.handleOpenPaymentPlanModal.bind(this)}
                                modal={
                                    <Modal
                                        isOpen={this.state.showPaymentPlanModal}
                                        onRequestClose={this.handleClosePaymentPlanModal.bind(this, false)}
                                        style={modalStyles.getModalStyles()}
                                        ariaHideApp={false}
                                    >
                                        <div class="row">
                                            <div class="modal-exit-icon pull-right" onClick={this.handleClosePaymentPlanModal.bind(this, false)}></div>
                                        </div>
                                        {hasPaymentPlan == false ? (
                                            <div class="row">
                                                <div class="modal-header">Add a Payment Plan</div>
                                            </div>
                                        ) : (
                                            <div class="row">
                                                <div class="modal-header">{tenantData.tenant_firstname} {tenantData.tenant_lastname} Payment Plan</div>
                                            </div>
                                        )}
                                        <div class="row">
                                            <div class="modal-section-title col-md-12">Payment Plan Information</div>
                                            {hasPaymentPlan == true && (
                                                <div>
                                                    <div class="row">
                                                        <div class="modal-section-note-title">Date Created</div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="modal-section-note-date">{moment.utc(paymentPlanData.effectiveDate).local().format('DD MMM YYYY, h:mm A')}</div>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        <form>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>What is the total amount to be paid over a period?</label>
                                                        <input type="text" value={rentAmount} onChange={this.onRentChange.bind(this)} class="form-control" />
                                                    </div>
                                                </div>
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>How many months should the payment be split out?</label>
                                                        <select class="form-control" value={termLength} onChange={this.onTermLengthChange.bind(this)}>
                                                            <option>Select a term length</option>
                                                            {termOptions}
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <div class="form-group">
                                                        <label>Total Charge per Month</label>
                                                        <input type="text" disabled value={"$" + totalMonth} class="form-control" />
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="content">
                                                    {hasPaymentPlan == false ? (
                                                        <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-3 col-xs-8 col-xs-offset-2">
                                                            <button type="button" id="add-payment-plan" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.handleCreatePaymentPlan.bind(this)}>
                                                                Create Payment Plan
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div class="col-md-12">
                                                            <div class="col-md-3 col-md-offset-2 col-sm-3 col-sm-offset-2 col-xs-6">
                                                                <button type="button" id="delete-payment-plan" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.handleDeletePaymentPlan.bind(this)}>
                                                                    Delete Plan
                                                                </button>
                                                            </div>
                                                            <div class="col-md-3 col-md-offset-1 col-sm-3 col-sm-offset-1 col-xs-6">
                                                                <button type="button" id="update-payment-plan" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.handleUpdatePaymentPlan.bind(this)}>
                                                                    Update Plan
                                                                </button>
                                                            </div>
                                                        </div>
                                                    )}
                                                    <div class="clearfix"></div>
                                                </div>
                                            </div>
                                        </form>
                                    </Modal>
                                }
                            />
                            <ActionCenterEntry
                                title="Background Screen"
                                description={backgroundScreenText}
                                buttonOverride={ screening != null ? (
                                    screening.order_status === 'Ready' ?
                                        <a target="_blank" href={this.state.screening_attachments ? this.state.screening_attachments[0].url : ''}>
                                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="action-center-button btn btn-secondary btn-info btn-fill" autoComplete="off">
                                                See Results
                                            </button>
                                        </a>
                                        :
                                        <div>
                                            <span>Order Status: {screening.order_status}</span>
                                        </div>
                                    ) : (
                                        <NavLink to={'/tenant/' + this.state.tenantID + '/screen'}>
                                            <button type="button" id="screen-tenant" data-loading-text="Loading..." class="action-center-button btn btn-secondary btn-info btn-fill" autoComplete="off">
                                                Screen Tenant
                                            </button>
                                        </NavLink>
                                    )
                                }
                            />
                            <ActionCenterEntry
                                title="Send Payment"
                                description="Send a payment"
                                buttonText="Create Payout"
                                buttonCallback={this.handleOpenTenantPayoutModal.bind(this)}
                                modal={
                                    <Modal
                                        isOpen={this.state.showTenantPayoutModal}
                                        onRequestClose={this.handleCloseTenantPayoutModal.bind(this, false)}
                                        style={modalStyles.getModalStyles()}
                                        ariaHideApp={false}
                                    >
                                        <div class="row">
                                            <div class="modal-exit-icon pull-right" onClick={this.handleCloseTenantPayoutModal.bind(this, false)}></div>
                                        </div>
                                        <div class="row">
                                            <div class="modal-header">Create Tenant Payment</div>
                                        </div>
                                        <div class="row">
                                            <div class="modal-section-title col-md-12">Transaction Information</div>
                                        </div>
                                        <form>
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="form-group">
                                                        <label>Amount*</label>
                                                        <div class="form-group">
                                                            <input type="text" class={"form-control input-group-dollar-addon " + this.state.transactionData.positive} value={this.state.transactionData.amount} onChange={this.handleAmountChange.bind(this)} placeholder="$0.00" />
                                                            <i class="form-control-feedback fa fa-dollar" style={{paddingTop:"5px"}}></i>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="form-group">
                                                        <label>Description</label>
                                                        <textarea rows="5" cols="80" class="form-control" value={this.state.transactionData.description} placeholder="Description" onChange={this.handleDescriptionChange.bind(this)}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="form-group">
                                                        <label>From Bank Account*</label>
                                                        <BankAccountSelect columnSize={0} title="" sortID={bankIdentifier} onChange={this.handleBankChange.bind(this)}/>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="content">
                                                {/* { newTransaction === true ? ( */}
                                                <div class="col-md-8 col-md-offset-4 col-sm-8 col-sm-offset-4 col-xs-8 col-xs-offset-2">
                                                    <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.addTransaction.bind(this)}>
                                                        Create Payout
                                                    </button>
                                                </div>
                                                {/* ) : (
                                                <div class="col-md-12">
                                                    <div class="col-md-3 col-md-offset-2 col-sm-3 col-sm-offset-1 col-xs-6 col-xs-offset-2" style={{padding: 0}}>
                                                        <button type="button" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.deleteTransaction.bind(this)}>
                                                            Delete Transaction
                                                        </button>
                                                    </div>
                                                    <div class="col-md-3 col-md-offset-1 col-sm-3 col-sm-offset-2 col-xs-6 col-xs-offset-2" style={{padding: 0, marginTop: window.innerWidth < 768 ? 10 : 0}}>
                                                        <button type="button" data-loading-text="Loading..." class="btn btn-secondary btn-info btn-fill" autoComplete="off" onClick={this.updateTransaction.bind(this)}>
                                                            Update Transaction
                                                        </button>
                                                    </div>
                                                </div>
                                                )} */}
                                                <div class="clearfix"></div>
                                                </div>
                                            </div>
                                        </form>
                                    </Modal>
                                }
                            />
                        </ActionCenterCard>
                        <div class="card">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="header">
                                        <h4 class="title"><span class="card-box-icon blue-card-icon-circle"><i class="icon-document-plus"></i></span> Documents</h4>
                                        <p class="category"></p>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="content">
                                            <p class="dropzone-subtitle">Upload relavant tenant documents</p>
                                            { attachments == null ? (
                                                null
                                            ) : (
                                                attachments
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="content">
                                            { this.state.dropZoneSetup !== undefined && (
                                                <div style={{textAlign: "center"}}>
                                                    <DropzoneComponent config={this.state.dropZoneConfig}
                                                        eventHandlers={this.state.dropZoneEventHandlers}
                                                        djsConfig={this.state.dropZoneJSConfig} />
                                                    <button type="button" class="btn btn-info btn-secondary btn-fill dropZone-upload" autoComplete="off" onClick={this.triggerUpload.bind(this, 0, "current")}>Upload</button>
                                                </div>
                                            )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row blue-bottom">
                    <div class="blue-bottom-center-align">
                        <div class="col-md-6 col-sm-6 col-xs-12 blue-bottom-btn-right-push">
                            <button type="button" id="delete-tenant" data-loading-text="Loading..." class="btn btn-danger btn-info btn-fill" autoComplete="off" onClick={this.handleDeleteTenant.bind(this)}>
                            Delete Tenant
                            </button>
                        </div>
                        <div class="col-md-3 col-sm-6 col-xs-12">
                            <button type="button" id="save-tenant" data-loading-text="Loading..." class="btn btn-primary btn-info btn-fill" autoComplete="off" onClick={this.handleSaveTenantData.bind(this)}>
                            Update Tenant
                            </button>
                        </div>
                        <div class="clearfix"></div>
                    </div>
                </div>
                </div>
            )
        }
    }
};


// WEBPACK FOOTER //
// app/components/Tenant/TenantEdit.jsx